import React from "react";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.section}
      className="bg-[#FDFBF7] border-t border-[#E5DCD3]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-16 md:py-24">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-10 items-end">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3.5">
              <img
                src="/brand/eilea_monogram.png"
                alt=""
                aria-hidden="true"
                className="h-11 md:h-12 w-auto object-contain"
              />
              <span className="font-logo text-2xl md:text-[1.85rem] text-[#2C2826] tracking-[0.22em]">
                eilea
              </span>
            </div>
            <p
              data-testid={FOOTER.tagline}
              className="mt-6 max-w-md text-[15px] md:text-base text-[#5C5652] font-light leading-relaxed"
            >
              Inspirat din skincare. Creat pentru corp.
            </p>
          </div>

          <div className="col-span-12 md:col-span-3">
            <p className="overline mb-5">— Navigare</p>
            <ul className="space-y-3">
              {[
                ["#benefits", "Beneficii"],
                ["#ingredients", "Ingrediente"],
                ["#waitlist", "Waitlist"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    className="text-[#2C2826] text-sm link-underline"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3">
            <p className="overline mb-5">— Contact</p>
            <ul className="space-y-3 text-sm text-[#2C2826]">
              <li>
                <a
                  href="mailto:eilea.beauty1@gmail.com"
                  data-testid="footer-contact-email"
                  className="link-underline"
                >
                  eilea.beauty1@gmail.com
                </a>
              </li>
              <li className="text-[#5C5652]">România</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 md:mt-24 pt-8 border-t border-[#E5DCD3] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[11px] uppercase tracking-[0.18em] text-[#8A7F77]">
            © {new Date().getFullYear()} EILEA. Toate drepturile rezervate.
          </p>
          <p className="text-[11px] uppercase tracking-[0.18em] text-[#8A7F77]">
            First release · 2026
          </p>
        </div>
      </div>
    </footer>
  );
}
